var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38672 18.0557V18.0557C5.38672 11.9339 10.3494 6.97119 16.4712 6.97119H27.5557M27.5557 6.97119L23.6435 2.2207M27.5557 6.97119L23.6435 11.7217",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5547 15.9443V15.9443C27.5547 22.0661 22.592 27.0288 16.4702 27.0288H5.38574M5.38574 27.0288L9.29791 31.7793M5.38574 27.0288L9.29791 22.2783",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.01,
    cy: 23.9846,
    r: 8.39669,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 0.730147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6443 27.8144C28.8811 27.8144 28.1961 27.3413 27.9184 26.6226L27.5587 25.6928C27.5218 25.6083 27.4826 25.5537 27.4411 25.5283C27.3994 25.5029 27.3317 25.4902 27.2382 25.4902H27.0781L26.9833 26.2762C26.8773 27.1542 26.1402 27.8144 25.2656 27.8144L26.0001 21.7722C26.1067 20.8942 26.8442 20.2344 27.7191 20.2344L27.2034 24.4827H27.3084C27.3953 24.4827 27.4652 24.4692 27.5187 24.4423C27.572 24.4153 27.6256 24.3663 27.6789 24.2954L28.4313 23.2528C28.7397 22.8256 29.23 22.5717 29.7529 22.5689L30.6329 22.5637L29.1809 24.4321C29.114 24.52 29.0407 24.5977 28.9605 24.6651C28.8804 24.7327 28.7968 24.7917 28.7102 24.8423C28.7804 24.8998 28.8412 24.9664 28.8929 25.0423C28.9447 25.1182 28.9905 25.2052 29.0305 25.3032L30.0719 27.8146H29.6443V27.8144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalIcon);
export default __webpack_public_path__ + "static/media/withdrawal-icon.9617f11446443ac75988bd1bc8d5a8b9.svg";
export { ForwardRef as ReactComponent };